module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/pdp_paperSmooth-ebe44dfbbb514dc34c958624c09dc0aa.jpg";